import { render, staticRenderFns } from "./FgOrderModal.vue?vue&type=template&id=5598260c&"
import script from "./FgOrderModal.vue?vue&type=script&lang=js&"
export * from "./FgOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports